import API from '@axios'
import { apiHelper } from '../helpers/apiHelper'

const API_URL = '/api/iam/roles'

export default {
  ...apiHelper(API_URL),
}
